export default __webpack_public_path__ + "static/media/green_star.605c9657.svg";